import lodash from 'lodash'

window._ = lodash

if (!Object.hasOwn) {
	Object.hasOwn = Object.call.bind(Object.hasOwnProperty)
}
